export const chartAOptions = {
  animation: {
    duration: 0,
  },
  legend: {
    display: false,
  },
  elements: {
    line: {
      tension: 0.4,
    },
  },
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        id: "x",
        scaleLabel: {
          display: false,
          labelString: "",
          fontStyle: "bold",
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: "x (F)",
          fontStyle: "bold",
        },
      },
    ],
  },
};

export const chartAAnnotations = {
  type: "line",
  display: true,
  scaleID: "x",
  value: 0,
  borderColor: "rgba(0, 0, 128, 1)",
  borderWidth: 3,
};
